module.exports = __webpack_public_path__ + "static/media/phrases.1b7a16e9.jpg";